'use client';

import Link from 'next/link';
import styles from './AnimatedCTAButton.module.css';

interface AnimatedCTAButtonProps {
    href: string;
    onClick?: () => void;
    className?: string;
}

export default function AnimatedCTAButton({ href, onClick, className }: AnimatedCTAButtonProps) {
    return (
        <Link
            href={href}
            className={`${styles.ctaButton} ${className || ''}`}
            onClick={onClick}
        >
            Start Your Business
        </Link>
    );
}
